import apiClient from 'utilities/apiClient';

export const admin = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.admin}/${url}`, payload, true);
};
export const admin_post = (url, payload) => {
  return apiClient.post(
    `${apiClient.Urls.admin_post}/${url}`,
    payload,
    true,
    'file'
  );
};
export const admin_patch = (url, payload) => {
  return apiClient.patch(
    `${apiClient.Urls.admin_post}/${url}`,
    payload,
    true,
    'file'
  );
};
export const admin_project_sites = (payload) => {
  return apiClient.get(`${apiClient.Urls.admin_project_sites}`, payload, true);
};
export const admin_bulk_gift_configs = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.admin}/admin-bulk-gift-configs`,
    payload,
    true
  );
};
export const admin_declaration_configs = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.admin}/admin-declaration-configs`,
    payload,
    true
  );
};
export const admin_unmapped_bus = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.admin}/admin-unmapped-bus`,
    payload,
    true
  );
};
export const admin_unmapped_project_sites = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.admin_unmapped_project_sites}`,
    payload,
    true
  );
};
export const admin_sbus = (payload) => {
  return apiClient.get(`${apiClient.Urls.admin_sbus}`, payload, true);
};
export const admin_sbgs = (payload) => {
  return apiClient.get(`${apiClient.Urls.admin_sbgs}`, payload, true);
};
export const create_or_update_sbu_api = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.create_or_update_sbu}`,
    payload,
    true,
    'file'
  );
};
export const create_or_update_sbg_api = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.create_or_update_sbg}`,
    payload,
    true,
    'file'
  );
};
export const project_sites = (payload) => {
  return apiClient.get(`${apiClient.Urls.project_sites}`, payload, true);
};
export const project_site_mapping = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.project_site_mapping}?UserId=${payload?.get(
      'UserId'
    )}&ProjectSiteId=${payload?.get('ProjectSiteId')}`,
    payload,
    true,
    'file'
  );
};
export const admin_inactive_users = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.admin}/admin-inactive-users`,
    payload,
    true
  );
};
export const admin_assign_gifts = (payload) => {
  return apiClient.post(
    `${apiClient.Urls.admin}/admin-assign-gifts`,
    payload,
    true,
    'file'
  );
};
export const admin_map_bus_and_project_sites = (payload) => {
  return apiClient.post(
    apiClient.Urls.admin_map_bus_and_project_sites,
    payload,
    true
  );
};
